
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import IconButton from "@/components/UI/IconButton.vue";

@Component({
  components: {
    IconButton
  }
})
export default class SingularityTooltip extends Vue {
  @Prop({ type: String, required: true }) text!: string;
}
